// Central data for the 5-step assessment
export const AGE_GROUPS = ["<20", "20-30", "30-40", "40-50", "50+"];

export const EXPERIENCE_OPTIONS = [
  "Never Traded",
  "<6 Months",
  "6-12 Months",
  "1-3 Years",
  "3-5 Years",
  "5+ Years",
];

export const MARKETS = ["Equity", "Options", "Futures", "Commodity", "Crypto", "Forex"];

export const STYLES = [
  "Scalping",
  "Intraday",
  "Swing",
  "Positional",
  "Option Buying",
  "Option Selling",
];

export const CAPITAL_OPTIONS = ["<25K", "25K-1L", "1L-5L", "5L-20L", "20L+"];

export const BROKERS = [
  "Zerodha",
  "Groww",
  "Angel One",
  "Upstox",
  "Dhan",
  "ICICI",
  "Kotak",
  "Other",
];

export const MONTHLY_RESULTS = [
  "Always Loss",
  "Mostly Loss",
  "Break Even",
  "Small Profit",
  "Consistent Profit",
];

export const WIN_RATES = ["Below 30%", "30-50%", "50-70%", "70%+", "Don't Know"];

export const BIGGEST_LOSSES = ["<5K", "5K-25K", "25K-1L", "Above 1L"];

export const CHALLENGES = [
  "Overtrading",
  "Emotional Trading",
  "Fear",
  "Greed",
  "No Discipline",
  "Risk Management",
  "Wrong Entries",
  "Wrong Exit",
  "Holding Losses",
  "Booking Profit Early",
  "No Strategy",
];

export const TRADE_REASONS = [
  "Extra Income",
  "Full Time",
  "Learning",
  "Wealth Creation",
  "Challenge",
];

export const GOALS = [
  "Become Consistent",
  "5% Monthly Return",
  "10% Monthly Return",
  "Become Professional Trader",
];

// Likert questions
export const PSYCHOLOGY_QUESTIONS = [
  { key: "revenge_trade", label: "I revenge trade." },
  { key: "move_stoploss", label: "I move my stop loss." },
  { key: "exit_early", label: "I exit winners too early." },
  { key: "hesitate", label: "I hesitate before entering." },
  { key: "follow_rules", label: "I always follow my trading rules." },
  { key: "fomo", label: "I trade because of FOMO." },
  { key: "overtrade", label: "I overtrade after losses." },
  { key: "stress", label: "I feel stressed while trading." },
  { key: "journal", label: "I maintain a trading journal." },
  { key: "risk_before_trade", label: "I define risk before every trade." },
];

export const LIKERT = [
  { value: 1, label: "Strongly Disagree" },
  { value: 2, label: "Disagree" },
  { value: 3, label: "Neutral" },
  { value: 4, label: "Agree" },
  { value: 5, label: "Strongly Agree" },
];

export const STORAGE_KEY = "methoda_assessment_draft_v1";

export const DEFAULT_DRAFT = {
  step: 0,
  data: {
    name: "",
    phone: "",
    email: "",
    city: "",
    age_group: "",
    experience: "",
    markets: [],
    styles: [],
    capital: "",
    broker: "",
    monthly_result: "",
    win_rate: "",
    biggest_loss: "",
    challenges: [],
    psychology: {
      revenge_trade: 3,
      move_stoploss: 3,
      exit_early: 3,
      hesitate: 3,
      follow_rules: 3,
      fomo: 3,
      overtrade: 3,
      stress: 3,
      journal: 3,
      risk_before_trade: 3,
    },
    trade_reason: "",
    goal: "",
  },
};
